package com.example.borshi.web.model

/**
 * External interfaces for Firebase data (JavaScript interop)
 * Used for Firestore document mapping
 */
external interface Referral {
    var id: String
    var referrerId: String
    var refereeId: String
    var status: String // "pending" | "completed" | "flagged" | "rate_limited"
    var createdAt: dynamic // Firestore Timestamp
    var completedAt: dynamic // Firestore Timestamp (can be null at runtime)
    var rewardAmount: Number
    var fraudSignals: dynamic
}

external interface ReferralCode {
    var code: String
    var userId: String
    var createdAt: dynamic
}

external interface ReferralStats {
    var totalReferrals: Int
    var totalBonus: Double
    var referralCode: String
}

/**
 * Kotlin data classes for type-safe usage in the app
 */
data class ReferralItem(
    val id: String = "",
    val referrerId: String = "",
    val refereeId: String = "",
    val status: ReferralStatus = ReferralStatus.PENDING,
    val createdAt: Long = 0,
    val completedAt: Long? = null,
    val rewardAmount: Double = 100.0
)

enum class ReferralStatus {
    PENDING,
    COMPLETED,
    FLAGGED,
    RATE_LIMITED;

    companion object {
        fun fromString(status: String?): ReferralStatus {
            return when (status?.lowercase()) {
                "completed" -> COMPLETED
                "flagged" -> FLAGGED
                "rate_limited" -> RATE_LIMITED
                else -> PENDING
            }
        }

        fun toDisplayString(status: ReferralStatus): String {
            return when (status) {
                PENDING -> "Pending"
                COMPLETED -> "Completed"
                FLAGGED -> "Flagged"
                RATE_LIMITED -> "Rate Limited"
            }
        }

        fun getColor(status: ReferralStatus): String {
            return when (status) {
                PENDING -> "#FFA726" // Orange
                COMPLETED -> "#66BB6A" // Green
                FLAGGED -> "#EF5350" // Red
                RATE_LIMITED -> "#9E9E9E" // Gray
            }
        }
    }
}

data class ReferralStatsData(
    val totalReferrals: Int = 0,
    val totalBonus: Double = 0.0,
    val referralCode: String = "",
    val pendingReferrals: Int = 0,
    val completedReferrals: Int = 0,
    val flaggedReferrals: Int = 0
)

